/* eslint-disable react/jsx-indent */
import React, { Component } from 'react'
import {
  Card, CardBody, Col, CardHeader, ModalFooter,
  Row, Button, Modal, ModalHeader, ModalBody,
  Label, FormGroup } from 'reactstrap'
import Select from '../../../components/Template/Input/Select'
import { selectValues, getRegs, insOrUp } from '../../../utils/fc'
import DataTable from '../../../components/Template/Table/DataTable'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import { add } from 'lodash'
import { TabList, TabPanel, Tabs, Tab } from 'react-tabs'
import Vagas from './Vagas'
import ModalConfirmacao from '../../Modals/ModalConfirmacao/ModalConfirmacao'
import oikosApi from '../../../services/oikos'
import qs from 'qs'
import ModalFormDocumentos from '../../Modals/ModalFormDocumentos/ModalFormDocumentos'
import { notifyError } from '../../../utils/notify'


class EquiProj extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: false,
      dataIsLoading: false,

      addEquiProjModalIsOpen: false,
      addEquiProjData: {},
      changeCoord: false,

      openModalChangeCoord: false,

      selEquiProj: false,
      equi: {},

      campos: [],
      isModalOpen: false,
    }
  }

  verifyIfProjHasCoord(projData) {
    const coord = projData.filter((col) => col.projAtuacao_id === 8)
    if (coord.length > 0) {
      const today = moment().format('YYYY-MM-DD')
      console.log('today', today)
      const coordAtivo = coord.filter((col) => {
        if (col.projEquipe_ini <= today && (!col.projEquipe_fim || col.projEquipe_fim >= today)) {
          return true;
        }
        return false;
      });
      if (coordAtivo.length > 0) {
        console.log('coord ativo', coordAtivo[0])
        return true;
      }
    }
    console.log('sem coord ativo')
    return false;
  }

  componentDidMount() {
    this.preloading()
  }

  ordenarPorLabel = (lista) => {
    console.log('lista', lista)
    return lista.sort((a, b) => {
      if (!a.label || !b.label) return 0;
      const labelA = a.label.toLowerCase();
      const labelB = b.label.toLowerCase();

      if (labelA < labelB) return -1;
      if (labelA > labelB) return 1;
      return 0;
    });
  }

  preloading = async() => {
    this.setState({dataIsLoading: true })
    const data = await getRegs('projEquipe', {proj_id: this.props.projId },
    {
      'pf_id': 'id_do_cidadao',
			'(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = projEquipe.pf_id)': 'pf_nomeExibicao',
      '(SELECT pf_cargo FROM pf WHERE pf.pf_id = projEquipe.pf_id)': 'pf_cargo',
      '(SELECT pf_numCons FROM pf WHERE pf.pf_id = projEquipe.pf_id)': 'pf_numCons',
      '(SELECT projAtuacao_nome FROM projAtuacao WHERE projAtuacao.projAtuacao_id = projEquipe.projAtuacao_id)': 'projAtuacao_nome'
		}, false )
    console.log("lista do EquiProj ", data)
    const coordenadorInativoSemDataFim = data.filter((col) => col.projAtuacao_id === 8 && !col.projEquipe_fim && Number(col.projEquipe_ativo) === 0);
    if (coordenadorInativoSemDataFim.length > 0) {
      notifyError('Existe um coordenador interno sem data de término. Por favor, ajuste as datas de início e fim dos coordenadores.')
    }
    const equipeAtivaMaisCoordenadores = data.filter((col) => {
      if (col.projAtuacao_id !== 8 && Number(col.projEquipe_ativo) === 0) {
        return false;
      } else if (col.projAtuacao_id === 8 && col.projEquipe_fim && Number(col.projEquipe_ativo) === 0) {
        return false;
      } else {
        return true;
      }
    });
    console.log('equipeAtivaMaisCoordenadores', equipeAtivaMaisCoordenadores)
    this.setState({ data: equipeAtivaMaisCoordenadores })

    this.setState({ selEquiProj: await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {dpto_id: 4}) })
    console.log('lista pf = ', this.state.selEquiProj)
    this.setState({ selAtuaProj: await selectValues('projAtuacao', 'projAtuacao_id', 'projAtuacao_nome') })
    console.log('lista atuação = ', this.state.selAtuaProj)

    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'tpDocumentoCampo',
      data: {
        tpDocumento_id: 25
      },
    })}`);
    console.log('res', res.data);

    let resCampos = [...res.data];
    resCampos = resCampos.map(campo => ({
      ...campo, sm: 3
    }))

    for (const [index, campo] of resCampos.entries()) {
      console.log(campo, index)
      if (campo.formatoCampo_id === 1) {
        const selOptions = await selectValues(campo.tpDocumentoCampo_tabRef, `${campo.tpDocumentoCampo_tabRef}_id`, campo.tpDocumentoCampo_colunaRef)
        const selOptionsSorted = this.ordenarPorLabel(selOptions);
        resCampos[index].selOptions = selOptionsSorted;
      }
    }

    this.setState({ campos: resCampos });

    this.setState({ dataIsLoading: false })
  }

  render() {

    const { dataIsLoading, data, addEquiProjData , addEquiProjModalIsOpen, selEquiProj, selAtuaProj } = this.state


    if (dataIsLoading) {
      return (
        <Card>
          <CardBody>
            <span>Carregando...</span>
          </CardBody>
        </Card>
      )
    }

    if (data) {
      return (
        <Row className="mt-3">
          <Col>
            <>
              <Button
                size="sm"
                color="link"
                className="mb-1 ml-1 px-0"
                onClick={() => this.setState({
                  addEquiProjModalIsOpen: true,
                  addEquiProjData: { proj_id: this.props.projId },
                })}
              >
                Adicionar novo
              </Button>
              <Modal
                centered={false}
                isOpen={ addEquiProjModalIsOpen}
                toggle={() => this.setState({ addEquiProjData: {}, addEquiProjModalIsOpen: false })}
              >
                <ModalHeader
                  toggle={() => this.setState({
                  addEquiProjData: {},
                  addEquiProjModalIsOpen: false,
                  })}
                >
                  Adicionar novo
                </ModalHeader>
                <ModalBody>
                  <Tabs>
                    <TabList>
                      <Tab>Equipe Interna</Tab>
                      <Tab>Terceirizados</Tab>
                    </TabList>
                    <TabPanel>
                      <FormGroup>
                      <Label>
                        Nome
                      </Label>
                      <Select
                        classNamePrefix="select2-selection"
                        placeholder="Selecionar..."
                        value={selEquiProj && selEquiProj?.filter(x => (x.value === addEquiProjData.pf_id))}
                        options={selEquiProj || []}
                        //isDisabled={!selEquiProj || (addEquiProjData.projEquipe_id)}
                        isLoading={!selEquiProj}
                        onChange={e => this.setState( {
                          addEquiProjData: {
                          ...addEquiProjData,
                          pf_id: e.value
                          }
                        })}
                      />
                      </FormGroup>
                      <FormGroup>
                        <Label>
                          Atuação
                        </Label>
                        <Select
                          classNamePrefix="select2-selection"
                          placeholder="Selecionar..."
                          value={selAtuaProj && selAtuaProj?.filter(x => (x.value === addEquiProjData.projAtuacao_id))}
                          options={selAtuaProj || []}
                          isDisabled={!selAtuaProj || (addEquiProjData.projEquipe_id)}
                          isLoading={!selAtuaProj}
                          onChange={e => {
                            if(addEquiProjData.pf_id && e.value === 8) {
                              this.setState({
                                changeCoord: true
                              })
                            } else {
                              this.setState({
                                changeCoord: false
                              })
                            }
                            this.setState( {
                            addEquiProjData: {
                            ...addEquiProjData,
                            projAtuacao_id: e.value
                            }
                          })}
                          }
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label>
                          Data inicial
                        </Label>

                        <DatePicker
                          placeholderText="__/__/_____"
                          locale="pt-BR"
                          className="form-control"
                          dateFormat="dd/MM/yyyy"
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          selected={addEquiProjData?.projEquipe_ini ? moment(addEquiProjData.projEquipe_ini).toDate() : null}
                          onChange={date => this.setState({
                            addEquiProjData: {
                              ...addEquiProjData,
                              projEquipe_ini: date ? moment(date).format('YYYY-MM-DD') : undefined
                            },
                          })} />
                      </FormGroup>
                      <FormGroup>
                        <Label>
                          Data final
                        </Label>

                        <DatePicker
                          placeholderText="__/__/_____"
                          locale="pt-BR"
                          className="form-control"
                          dateFormat="dd/MM/yyyy"
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          selected={addEquiProjData?.projEquipe_fim ? moment(addEquiProjData.projEquipe_fim).toDate() : null}
                          onChange={date => {
                            console.log('date', date)
                            this.setState({
                            addEquiProjData: {
                              ...addEquiProjData,
                              projEquipe_fim: date ? moment(date).format('YYYY-MM-DD') : null
                            },
                          })}} />
                      </FormGroup>
                    </TabPanel>
                    <TabPanel>
                      <FormGroup>
                        <div className='d-flex justify-content-between align-items-center'>
                          <Label>
                            Contrato
                          </Label>
                          <Button
                            size="sm"
                            color="link"
                            className="ml-2 px-0"
                            onClick={(e)=>{
                              e.preventDefault();
                            }}
                          >
                            Adicionar contrato
                          </Button>
                        </div>
                        <Select
                          classNamePrefix="select2-selection"
                          placeholder="Selecione um contrato de fornecedor..."
                          value={[{value: 1, label: 'Contrato para Biólogo'}, {value: 2, label: 'Contrato para Químico'}, {value: 3, label: 'Contrato para Pintor'}].filter(x => (x.value === addEquiProjData.contrForn_id))}
                          options={[{value: 1, label: 'Contrato para Biólogo'}, {value: 2, label: 'Contrato para Químico'}, {value: 3, label: 'Contrato para Pintor'}]}
                          isDisabled={![{value: 1, label: 'Contrato para Biólogo'}, {value: 2, label: 'Contrato para Químico'}, {value: 3, label: 'Contrato para Pintor'}]}
                          isLoading={![{value: 1, label: 'Contrato para Biólogo'}, {value: 2, label: 'Contrato para Químico'}, {value: 3, label: 'Contrato para Pintor'}]}
                          onChange={e => this.setState( {
                            addEquiProjData: {
                            ...addEquiProjData,
                            contrForn_id: e.value
                            }
                          })}
                        />
                      </FormGroup>
                      {addEquiProjData.contrForn_id &&
                        <FormGroup>
                          <div className='d-flex justify-content-between align-items-center'>
                            <Label>
                              Pessoa Física
                            </Label>
                            <Button
                              size="sm"
                              color="link"
                              className="ml-2 px-0"
                              onClick={(e)=>{
                                e.preventDefault();
                              }}
                            >
                              Adicionar fornecedor
                            </Button>
                          </div>
                          <Select
                            classNamePrefix="select2-selection"
                            placeholder="Selecione um contrato de fornecedor..."
                            value={[{value: 1, label: 'Pedro'}, {value: 2, label: 'Bruna'}, {value: 3, label: 'Fulano'}].filter(x => (x.value === addEquiProjData.pf_id))}
                            options={[{value: 1, label: 'Pedro'}, {value: 2, label: 'Bruna'}, {value: 3, label: 'Fulano'}]}
                            isDisabled={!addEquiProjData.contrForn_id}
                            isLoading={![{value: 1, label: 'Pedro'}, {value: 2, label: 'Bruna'}, {value: 3, label: 'Fulano'}]}
                            onChange={e => this.setState( {
                              addEquiProjData: {
                              ...addEquiProjData,
                              pf_id: e.value,
                              }
                            })}
                          />
                        </FormGroup>
                      }
                    </TabPanel>
                  </Tabs>
                </ModalBody>
                <ModalFooter>
                  <Button
                    type="button"
                    onClick={() => this.setState({ addEquiProjData: {}, addEquiProjModalIsOpen: false })}
                    color="light"
                    className="waves-effect"
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="button"
                    color="primary"
                    className="waves-effect waves-light"
                    onClick={async () => {
                      /* if (this.verifyIfProjHasCoord(data) && this.state.changeCoord) {
                        console.log(data)
                        console.log('mudou coord')
                        this.setState({openModalChangeCoord: true})
                        return
                      } */
                      const projEquipe_id = await insOrUp( 'projEquipe', addEquiProjData)

                      /* if (this.state.changeCoord) {
                        await insOrUp( 'proj', {proj_id: addEquiProjData.proj_id, proj_coord: addEquiProjData.pf_id})
                      } */
                      this.preloading()
                      this.setState({ addEquiProjData: {}, addEquiProjModalIsOpen: false })
                    }
                    }

                  >
                    Adicionar
                  </Button>
                </ModalFooter>
              </Modal>
              <ModalConfirmacao onClosed={() => {this.setState( prevState => ({ openModalChangeCoord: !prevState.openModalChangeCoord}) )}} openModal={this.state.openModalChangeCoord} title={'Esse projeto já possui um coordenador'} text={'Por favor, finalize o cargo atual de coordenador interno'}/>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <CardHeader>
                        Equipe
                      </CardHeader>
                      <DataTable
                        className="table-clickable"
                        data={{
                          columns: [
                            {
                              label: '',
                              field: 'but1',
                            },
                            {
                              label: '',
                              field: 'but',
                            },
                            {
                              label: 'Nome',
                              field: 'nome',
                            },
                            {
                              label: 'Formação',
                              field: 'formacao',
                            },
                              {
                              label: 'Registro n°',
                              field: 'registro_num',
                            },
                            {
                              label: 'Atuação',
                              field: 'atuacao',
                            },
                            {
                              label: 'ART nº',
                              field: 'art_num',
                            },
                            {
                              label: 'Vínculo',
                              field: 'vinculo',
                            },
                            {
                              label: 'Data de início',
                              field: 'projEquipe_ini',
                            },
                            {
                              label: 'Data de término',
                              field: 'projEquipe_fim',
                            },
                            /* {
                              label: 'Documentos',
                              field: 'doc_equipe',
                            }, */
                          ],
                          rows: data.map(i => ({
                            but1:
                              <Button
                                title="Editar"
                                className="ml-2"
                                color="light"
                                size="sm"
                                onClick={()  => {
                                    this.setState({
                                      addEquiProjData: {
                                        projEquipe_id: i.projEquipe_id,
                                        pf_id: i.pf_id,
                                        proj_id: i.proj_id,
                                        projAtuacao_id: i.projAtuacao_id,
                                        projEquipe_ini: i.projEquipe_ini ? moment(i.projEquipe_ini).format('YYYY-MM-DD') : undefined,
                                        projEquipe_fim: i.projEquipe_fim ? moment(i.projEquipe_fim).format('YYYY-MM-DD') : undefined,

                                      },
                                      addEquiProjModalIsOpen:true })
                                }}
                              >
                                <i className="ri-pencil-fill" />
                              </Button>,
                            but:
                            <Button
                              title="Excluir"
                              className="ml-2"
                              color="light"
                              size="sm"
                              onClick= {async () => {
                                if (i.projAtuacao_id === 8 && !i.projEquipe_fim) {
                                  notifyError('Não é possível excluir um coordenador interno sem data de término. Por favor, ajuste as datas de início e fim dos coordenadores para excluir ou inativar um coordenador interno.')
                                  return
                                }
                                this.setState({ dataIsLoading: true  })
                                const projEquipe_id = await insOrUp( 'projEquipe', {projEquipe_id: i.projEquipe_id, projEquipe_ativo: 0 })
                                this.setState({ data: this.state.data.filter(item => item.projEquipe_id !== projEquipe_id), dataIsLoading: false })
                              }}
                            >
                              <i className="ri-delete-bin-6-line" />
                            </Button>,
                            nome: i.pf_nomeExibicao,
                            formacao: i.pf_cargo,
                            registro_num: i.pf_numCons,
                            atuacao: i.projAtuacao_nome,
                            projEquipe_ini: i.projEquipe_ini ? moment(i.projEquipe_ini).format('DD/MM/YYYY') : undefined,
                            projEquipe_fim: i.projEquipe_fim ? moment(i.projEquipe_fim).format('DD/MM/YYYY') : undefined,
                            art_num: i.art ? i.art : <Button color='light' size="sm" onClick={() => this.setState({isModalOpen: true})}><i className=" ri-file-upload-fill"/></Button>,
                            vinculo: i.vinc,
                            doc_equipe: i.doc_e,
                            view: <Button><i className=" ri-file-download-fill"/></Button>,
                          })),
                        }}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </>
          </Col>
          {this.state.campos.length > 0 && (
            <ModalFormDocumentos
              openModal={this.state.isModalOpen}
              onClosed={() => this.setState({isModalOpen: false})}
              title={'Novo documento de ART'}
              data={this.state.campos}
              size='lg'
            />
          )}
        </Row>
      )
    }

    return null
  }
}
export default EquiProj
